import { FC, useState } from 'react'
import { BookingType } from '../components/TimelineView'
import { MeetingRoom } from '../components/ui/MeetingroomCard'

// 회의실 목데이터
interface MeetingRoomType {
  id: string
  name: string
  capacity: number
  hasProjector?: boolean
  hasWifi?: boolean
  imageUrl?: string
  bookings: BookingType[]
}

// 목데이터 정의
const meetingRooms: MeetingRoomType[] = [
  {
    id: '1',
    name: '대회의실',
    capacity: 20,
    hasProjector: true,
    hasWifi: true,
    imageUrl: '/meetingroomB.jpg',
    bookings: [
      {
        id: '101',
        startTime: 10 * 60, // 10:00
        endTime: 11 * 60, // 11:00
        title: '팀 미팅',
        bookedBy: '김철수',
      },
      {
        id: '102',
        startTime: 14 * 60, // 14:00
        endTime: 16 * 60, // 16:00
        title: '프로젝트 기획',
        bookedBy: '박지영',
        description: '신규 프로젝트 기획 회의',
      },
    ],
  },
  {
    id: '2',
    name: '소회의실 A',
    capacity: 8,
    hasProjector: true,
    hasWifi: true,
    imageUrl: '/meetingroomA.jpg',
    bookings: [
      {
        id: '201',
        startTime: 9 * 60, // 9:00
        endTime: 10 * 60, // 10:00
        title: '일일 스크럼',
        bookedBy: '개발팀',
      },
    ],
  },
  {
    id: '3',
    name: '소회의실 B',
    capacity: 6,
    hasWifi: true,
    bookings: [],
  },
]

const MeetingRoomList: FC = () => {
  const [currentTime] = useState(() => {
    const now = new Date()
    return now.getHours() * 60 + now.getMinutes()
  })

  return (
    <div className="grid grid-cols-1 gap-6">
      {meetingRooms.map((room) => (
        <MeetingRoom key={room.id} room={room} currentTime={currentTime} />
      ))}
    </div>
  )
}

export default MeetingRoomList
